

















































































import { Component } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import {
  alertStore,
  appStore,
  modalErrorStore,
  systemCodeStore
} from '@/utils/store-accessor'
import {
  UsageStatisticsReferenceTable,
  UsageStatisticsReferenceTableItem
} from '@/components/organisms/UsageStatisticsReferenceTable'
import {
  UsageStatisticsEventTable,
  UsageStatisticsEventTableItem,
  defaultUsageStatisticsEventTableItem
} from '@/components/organisms/UseStatisticsEventTable'
import {
  NAV_LOADING_END,
  NAV_LOADING_START,
  PAGE_LOADING_END,
  PAGE_LOADING_START
} from '@/config/event'
import {
  Alert,
  AlertMessage,
  defaultUsageStatistics,
  ErrorMessage,
  SystemCode,
  UsageStatistics,
  usageStatisticsApi,
  UsageStatisticsCopy
} from '@/api'
import { AlertFactory } from '@/factory'
import { AlertCodeALC00002 } from '@/types'
import dayjs from '@/node_modules/dayjs'
import {
  UsageStatisticsSearchCondition,
  defaultUsageStatisticsSearchConditionItem,
  UsageStatisticsSearchConditionItem
} from '@/components/organisms/UsageStatisticsSearchCondition'
import { CODE_KEY } from '@/config'
import {
  UsageStatisticsCopyTable,
  UsageStatisticsCopyTableItem
} from '@/components/organisms/UseStatisticsCopyTable'

interface InputUsageStatisticsItem {
  references: UsageStatisticsReferenceTableItem[]
  copies: UsageStatisticsCopyTableItem[]
  events: UsageStatisticsEventTableItem[]
}

const defaultInputUsageStatisticsItem = (): InputUsageStatisticsItem => ({
  references: [],
  copies: [],
  events: []
})

const TabType = {
  Reference: 'reference',
  Copy: 'copy',
  Event: 'event'
}
type TabType = typeof TabType[keyof typeof TabType]

@Component({
  components: {
    UsageStatisticsCopyTable,
    UsageStatisticsSearchCondition,
    UsageStatisticsEventTable,
    UsageStatisticsReferenceTable,
    ModalFooter
  }
})
export default class ModalUsageStatistics extends ModalComponentBaseVue {
  activeTab: TabType = TabType.Reference

  dialog: boolean = false

  usageStatistics: UsageStatistics = defaultUsageStatistics()

  searchCondition: UsageStatisticsSearchConditionItem = defaultUsageStatisticsSearchConditionItem()

  inputItem: InputUsageStatisticsItem = defaultInputUsageStatisticsItem()

  tableBodyHeight: number = 0

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get fontSizeType(): string {
    return appStore._fontSizeType
  }

  get tabStyles(): object {
    if (this.fontSizeType === 'normal') {
      return {}
    }

    return {
      'font-size': this.fontSize + 'px'
    }
  }

  get tabType(): any {
    return TabType
  }

  get referenceTypeSystemCodes(): SystemCode[] {
    return systemCodeStore.filterByCodeKey(CODE_KEY.REFERENCE_TYPE.KEY)
  }

  get statisticsUserTypeSystemCodes(): SystemCode[] {
    return systemCodeStore.filterByCodeKey(CODE_KEY.STATISTICS_USER_TYPE.KEY)
  }

  get copyTypeSystemCodes(): SystemCode[] {
    return systemCodeStore.filterByCodeKey(CODE_KEY.COPY_TYPE.KEY)
  }

  get eventTypeSystemCodes(): SystemCode[] {
    return systemCodeStore.filterByCodeKey(CODE_KEY.EVENT_TYPE.KEY)
  }

  open(): void {
    systemCodeStore.fetchAllAndMergeByCodeKeys([
      CODE_KEY.COPY_TYPE.KEY,
      CODE_KEY.REFERENCE_TYPE.KEY,
      CODE_KEY.EVENT_TYPE.KEY,
      CODE_KEY.STATISTICS_USER_TYPE.KEY
    ])
    this.dialog = true
    this.getUsageStatistics()
    window.addEventListener('resize', this.calculateTableHeight)
    this.$nextTick(this.calculateTableHeight)
  }

  close(): void {
    this.dialog = false
    this.activeTab = TabType.Reference
    this.dialog = false
    this.usageStatistics = defaultUsageStatistics()
    this.searchCondition = defaultUsageStatisticsSearchConditionItem()
    this.inputItem = defaultInputUsageStatisticsItem()
    window.removeEventListener('resize', this.calculateTableHeight)
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  tabClass(value: TabType): string {
    return this.activeTab === value ? 'active' : ''
  }

  onClickTab(value: TabType): void {
    if (value === this.activeTab) {
      return
    }

    this.activeTab = value

    this.$nextTick(this.calculateTableHeight)
  }

  onClickPrev(): void {
    this.onGetUsageStatistics(() => {
      if (this.searchCondition.targetDate.input.length === 8) {
        this.searchCondition.targetDate.input = dayjs(
          this.searchCondition.targetDate.input
        )
          .subtract(1, 'day')
          .format('YYYYMMDD')
      }
    })
  }

  onClickNext(): void {
    this.onGetUsageStatistics(() => {
      if (this.searchCondition.targetDate.input.length === 8) {
        this.searchCondition.targetDate.input = dayjs(
          this.searchCondition.targetDate.input
        )
          .add(1, 'day')
          .format('YYYYMMDD')
      }
    })
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-usage-statistics')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  isActiveTab(value: TabType) {
    return this.activeTab === value
  }

  setErrorMessage(alerts: Alert[], obj: any): void {
    alerts.forEach(alert => {
      if (alert.attribute === '') return false
      const key: keyof typeof obj = alert.attribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      ) as typeof obj
      const subKey: string = alert.subAttribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      )
      const splitKeys: string[] = (key as string).split('.')

      if (
        obj[key] !== undefined &&
        subKey !== '' &&
        Array.isArray(obj[key]) &&
        Object.prototype.toString
          .call(obj[key][alert.index][subKey])
          .slice(8, -1) === 'Object' &&
        (obj[key][alert.index][subKey] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key][alert.index][subKey] as any).errorMessage = alert.message
        return
      }

      if (
        obj[key] !== undefined &&
        Object.prototype.toString.call(obj[key]).slice(8, -1) === 'Object' &&
        (obj[key] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key] as any).errorMessage = alert.message
        return
      }

      if (splitKeys.length > 1 && subKey === '') {
        if (
          obj[splitKeys[0]][splitKeys[1]] !== undefined &&
          Object.prototype.toString
            .call(obj[splitKeys[0]][splitKeys[1]])
            .slice(8, -1) === 'Object' &&
          (obj[splitKeys[0]][splitKeys[1]] as any).hasOwnProperty(
            'errorMessage'
          )
        ) {
          ;(obj[splitKeys[0]][splitKeys[1]] as any).errorMessage = alert.message
        }
      }
    })
  }

  onGetUsageStatistics(okCallback?: () => void): void {
    const alert: Alert = AlertFactory.create(AlertCodeALC00002)
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: () => {
        if (okCallback) {
          okCallback()
        }
        this.getUsageStatistics()
      }
    })
  }

  async getUsageStatistics(): Promise<void> {
    this.$eventBus.emit(NAV_LOADING_START)

    try {
      this.usageStatistics = await usageStatisticsApi.getUsageStatistics({
        targetDate: this.searchCondition.targetDate.input
      })

      const events: UsageStatisticsEventTableItem[] = this.usageStatistics.events.map(
        event => {
          return {
            isRegistered: true,
            eventType: {
              input: event.eventType.code,
              shortName: event.eventType.shortName,
              errorMessage: ''
            },
            counter: {
              input: String(event.counter) || '0'
            },
            inputs: this.statisticsUserTypeSystemCodes.map(
              statisticsUserTypeSystemCode => {
                return {
                  userType: statisticsUserTypeSystemCode,
                  counter: {
                    input: String(
                      event.inputs.find(
                        input =>
                          input.userType.code ===
                          statisticsUserTypeSystemCode.code
                      )?.counter ?? 0
                    )
                  }
                }
              }
            )
          }
        }
      )

      this.inputItem = {
        references: this.referenceTypeSystemCodes.map(
          referenceTypeSystemCode => {
            return {
              referenceType: referenceTypeSystemCode,
              inputs: this.statisticsUserTypeSystemCodes.map(
                statisticsUserTypeSystemCode => {
                  return {
                    userType: statisticsUserTypeSystemCode,
                    counter: {
                      input: String(
                        this.usageStatistics.references
                          .find(
                            reference =>
                              reference.referenceType.code ===
                              referenceTypeSystemCode.code
                          )
                          ?.inputs.find(
                            input =>
                              input.userType.code ===
                              statisticsUserTypeSystemCode.code
                          )?.counter ?? 0
                      )
                    }
                  }
                }
              )
            }
          }
        ),
        copies: this.copyTypeSystemCodes.map(copyTypeSystemCode => {
          const targetCopy:
            | UsageStatisticsCopy
            | undefined = this.usageStatistics.copies.find(
            copy => copy.copyType.code === copyTypeSystemCode.code
          )

          return {
            copyType: copyTypeSystemCode,
            counter: {
              input: String(targetCopy?.counter ?? 0)
            },
            counterNumber: {
              input: String(targetCopy?.counterNumber ?? 0)
            }
          }
        }),
        events:
          events.length > 0 ? events : [defaultUsageStatisticsEventTableItem()]
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts, this.searchCondition)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }

  async registerUsageStatistics(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await usageStatisticsApi.registerUsageStatistics({
        targetDate: this.searchCondition.targetDate.input,
        references: this.inputItem.references
          .filter(
            reference =>
              reference.inputs.filter(input => Number(input.counter.input) > 0)
                .length > 0
          )
          .map(reference => {
            return {
              referenceType: reference.referenceType.code,
              inputs: reference.inputs
                .filter(input => Number(input.counter.input) > 0)
                .map(input => {
                  return {
                    userType: input.userType.code,
                    counter: !isNaN(Number(input.counter.input))
                      ? Number(input.counter.input)
                      : input.counter.input
                  }
                })
            }
          }),
        copies: this.inputItem.copies
          .filter(
            copy =>
              Number(copy.counter.input) > 0 ||
              Number(copy.counterNumber.input) > 0
          )
          .map(copy => {
            return {
              copyType: copy.copyType.code,
              counter: !isNaN(Number(copy.counter.input))
                ? Number(copy.counter.input)
                : copy.counter.input,
              counterNumber: !isNaN(Number(copy.counterNumber.input))
                ? Number(copy.counterNumber.input)
                : copy.counterNumber.input
            }
          }),
        events: this.inputItem.events
          .filter(event => event.eventType.input !== '')
          .map(event => {
            return {
              eventType: event.eventType.input,
              counter: !isNaN(Number(event.counter.input))
                ? Number(event.counter.input)
                : event.counter.input,
              inputs: event.inputs.map(input => {
                return {
                  userType: input.userType.code,
                  counter: !isNaN(Number(input.counter.input))
                    ? Number(input.counter.input)
                    : input.counter.input
                }
              })
            }
          }),
        revision: this.usageStatistics.revision
      })

      this.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts, this.inputItem)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }
}
